import React from 'react';
import './style.scss';
import Topbar from './sections/Topbar';
import Header from './sections/Header';
import Info from './sections/Info';
import Steps from './sections/Steps';
import Footer from './sections/Footer';

const LoginPage = () => {
	return (
		<div className="login-page">
			<Topbar />
			<Header />
			<Info />
			<Steps />
			<Footer />
		</div>
	);
};

export default LoginPage;
